import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import NavItem from './NavItem';
import './Nav.css';

const Nav = () => {
  const [activeSection, setActiveSection] = useState('intro');
  const [isScrolled, setIsScrolled] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const sections = useMemo(() => [
    { id: 'intro', label: 'Introduction' },
    { id: 'projects', label: 'Projects' },
    { id: 'knowledge', label: 'Knowledge Base' },
    { id: 'contact', label: 'Contact' }
  ], []); // Empty dependency array since sections never change

  useEffect(() => {
    const handleScroll = () => {
      if (isMobile) {
        requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 50);
          
          sections.forEach(({ id }) => {
            const element = document.getElementById(id);
            if (element) {
              const rect = element.getBoundingClientRect();
              if (rect.top <= window.innerHeight / 2 && rect.bottom >= 0) {
                setActiveSection(id);
              }
            }
          });
        });
      } else {
        // Original desktop behavior
        setIsScrolled(window.scrollY > 50);
        sections.forEach(({ id }) => {
          const element = document.getElementById(id);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 3 && rect.bottom >= window.innerHeight / 3) {
              setActiveSection(id);
            }
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections, isMobile]);

  const containerVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.nav
      className={`nav-container ${isScrolled ? 'scrolled' : ''}`}
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div className="nav-content">
        {sections.map((section, index) => (
          <motion.div
            key={section.id}
            variants={itemVariants}
            custom={index}
            style={{"--index": index}}
          >
            <NavItem
              {...section}
              isActive={activeSection === section.id}
            />
          </motion.div>
        ))}
      </motion.div>
      <p className="nav-mobile-message">
        For the best experience, visit this page on laptop or desktop to see the cool animations.
      </p>
    </motion.nav>
  );
};

export default Nav;
